import { updateProfile } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { convertSnapshot } from "../../cnr/contexts/contextHelpers";
import { dispatchProps } from "../../cnr/reducers/reducerHelpers/dispatchProps";
import { createInitials } from "../../common/dataAdjust";
import { gEnums } from "../../enums/globalEnums";
import { createRefPath, createRefPath_client } from "../../firestoreData/appData/appRefPaths";

const profileCollection = 'clients'
const _allowProfileUpdate = true

export const updateAppProfileDirect = async (mainDb, mainAuth, appUserSession, pathViews, profileData, callback) => {

  let updateData = {}
  const { appUserAccessType, email } = appUserSession ?? {}

  let _profileType;

  switch (appUserAccessType) {
    case gEnums.appUserAccessTypes.admin:
    case gEnums.appUserAccessTypes.superAdmin:
    case gEnums.appUserAccessTypes.superAdminDeveloper:
      _profileType = gEnums.profileTypes.adminProfiles
      break;
    default:
      _profileType = gEnums.profileTypes.clientProfiles
      break
  }

  switch (_profileType) {
    case gEnums.profileTypes.adminProfiles:
      updateData = {
        displayName: profileData.displayName,
        firstName: profileData.firstName,
        lastName: profileData.lastName,
        initials: profileData.initials,
      }
      const updateProps_admin = ['firstName', 'lastName', 'initials', 'email', 'phoneNumber', 'street', 'city', 'state', 'zip', 'displayName', 'aboutMe', 'bio', 'locationSettings', 'notificationSettings', 'permissionSettings']
      ammendUpdateData(updateProps_admin, profileData, updateData)
      if (profileData.aboutMe) { updateData.aboutMe = profileData.aboutMe }
      if (profileData.bio) { updateData.bio = profileData.bio }
      if (profileData.notificationSettings) { updateData.notificationSettings = profileData.notificationSettings }
      if (profileData.permissionSettings) { updateData.permissionSettings = profileData.permissionSettings }
      if (profileData.profileUpdated) { updateData.profileUpdated = profileData.profileUpdated }
      break;

    default:
      updateData = {}
      const updateProps = ['firstName', 'lastName', 'initials', 'email', 'phoneNumber', 'street', 'city', 'state', 'zip', 'displayName',
        'aboutMe', 'bio',
        'hideAboutMeFromApp', 'hideAddressFromApp', 'hideBioFromApp', 'hideEmailFromApp', ' hidePhoneNumberFromApp',
        'locationSettings', 'notificationSettings', 'permissionSettings', 'disclaimerResponses',
        'appUserPrivacy'
      ]
      ammendUpdateData(updateProps, profileData, updateData)
      if (!profileData.displayName && updateData.firstName && updateData.lastName) { updateData.displayName = updateData.firstName + ' ' + updateData.lastName }
      if (!updateData.initials && updateData.displayName) { updateData.initials = createInitials(updateData.displayName) }
      if (profileData.profileUpdated) { updateData.profileUpdated = profileData.profileUpdated }
      break;
  }

  let _baseRef;

  switch (_profileType) {
    case gEnums.profileTypes.adminProfiles:
      _baseRef = createRefPath(['profiles'])
      break;
    default:
      _baseRef = createRefPath_client(pathViews, ['profiles'])
  }

  const cr = collection(mainDb, _baseRef)
  const q = query(cr, where("email", "==", email));

  getDocs(q).then(data => {
    if (!data.empty) {
      const itemData = convertSnapshot(data, false, { returnFirstObject: true })
      const { _itemKey } = itemData
      const _setRef = createRefPath([_itemKey], _baseRef)
      console.log('_setRef', _setRef, itemData)
      if (_allowProfileUpdate) {
        updateAuthProfile(profileData)
        database_fns.set_doc(_setRef, updateData, true, callback)
      } else {
        console.log('_setRef', _setRef, updateData)
      }
    } else {
      const _addRef = createRefPath([email], _baseRef)
      updateData.email = email
      console.log('_addRef', _addRef, itemData)
      if (_allowProfileUpdate) {
        updateAuthProfile(mainAuth, profileData)
        database_fns.set_doc(_addRef, updateData, callback)
      } else {
        console.log('_addRef', _addRef, updateData)
      }
    }
  }).catch(error => {
    callback({ type: dispatchProps.error, error })
  })
}

const updateAuthProfile = (mainAuth, profileData) => {
  const currentUser = mainAuth.currentUser
  if (!currentUser.displayName) {
    // update profile if display name is missing  
    updateProfile(mainAuth.currentUser, {
      displayName: profileData.firstName + ' ' + profileData.lastName
    }).then(() => {
      // return { success: true, signInResponseType: signInResponseTypes.signInSuccess }
      // ...
    }).catch((error) => {
      // return { success: true, signInResponseType: signInResponseTypes.signInSuccess }
      // ...
    });
  } else {
    // resp = { success: true, signInResponseType: signInResponseTypes.signInSuccess }
  }
}

const ammendUpdateData = (updateProps, profileData, updateData) => {
  updateProps.forEach(prop => {
    if (profileData[prop]) { updateData[prop] = profileData[prop] }
  })
}